import React, { useEffect, useState } from 'react';
/**
 * This will copy the functionality in _fyh/src/components/shared/counter.js
 * - since the dependency versions differ between FYH and Viewport Map, we
 *   are unable to reuse the functionality directly, but once the apps
 *   get consolidated, we will be able to have a single Slider component
 */
const Counter = ({ label, count, minCount = null, onCountChange, className }) => {
    const [countState, setCountState] = useState((minCount && (count < minCount)) ? minCount : count);
    const idPrefix = label.toLowerCase().replace(' ', '-');
    useEffect(() => {
        setCountState((minCount && (count < minCount)) ? minCount : count);
    }, [count]);
    return (React.createElement("div", { className: 'counter' + (className ? ' ' + className : '') },
        React.createElement("label", { className: "counter__label", htmlFor: `${idPrefix}-count` }, label),
        React.createElement("div", null,
            React.createElement("input", { type: "button", className: "counter__button counter__button--left", "aria-label": "Remove", onClick: countState === minCount
                    ? () => {
                        setCountState(countState);
                        onCountChange(countState);
                    }
                    : () => {
                        setCountState(countState - 1);
                        onCountChange(countState - 1);
                    } }),
            React.createElement("input", { className: "counter__input", value: `${countState}+`, readOnly: true, id: `${idPrefix}-count` }),
            React.createElement("input", { type: "button", className: "counter__button counter__button--right", "aria-label": "Add", onClick: () => {
                    setCountState(countState + 1);
                    onCountChange(countState + 1);
                } }))));
};
export default Counter;
